/*Generated from the `:::slide{key="2222df1b-5be1-48c1-bffa-d94623ad94ed" slug="level-1/after-土/same-decomposition"}` (simplified/001/013/土.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, SlideTitle, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!SlideTitle) _missingMdxReference("SlideTitle", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.a) _missingMdxReference("html.a", true);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "SlideTitle",
      count: "4",
      children: _jsx(SlideTitle, {
        children: "Identical Decompositions",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsx(html.p, {
        children: "Some characters break into the exact same parts and still mean different things.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsxs(html.p, {
        children: ["土 and the next character, 士, are both a ", _jsx(html.a, {
          href: "%E5%8D%81",
          children: _jsx(html.em, {
            children: "cross",
            components: html
          }),
          components: html
        }), " on the ", _jsx(html.a, {
          href: "%EF%BC%BF",
          children: _jsx(html.em, {
            children: "floor",
            components: html
          }),
          components: html
        }), ". They differ only in which horizontal stroke is longer: 土 is wider at the bottom, 士 at the top."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsx(html.p, {
        children: "When two cards share a decomposition, compare their shapes side by side — the contrast is the lesson.",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
